<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Запросы</div>
                <div class="pull-right">
                  <a
                    @click="showNewRequestForm"
                    class="btn btn-success"
                    style="margin-right: 12px; padding: 4px 15px; margin-bottom: 8px;"
                  >
                    Создать новый запрос
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form>
              <div class="row myrow project-filter filter-wrapper-stl">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_number"
                    type="text"
                    class="filter-input-stl"
                    placeholder="Номер запроса"
                    v-model="filter.number"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    type="text"
                    class="filter-input-stl"
                    placeholder="Номер проекта"
                    v-model="filter.project_number"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!statusRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.status"
                    :options="statuses"
                    :multiple="true"
                    placeholder="Статус запроса"
                  >
                    <span slot="noResult">Статус не найден</span>
                    <span slot="noOptions">Статус не найден</span>
                  </Multiselect>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!statusRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.types"
                    :options="types "
                    :multiple="true"
                    placeholder="Тип запроса"
                  >
                    <span slot="noResult">Тип запроса не найден</span>
                    <span slot="noOptions">Тип запроса не найден</span>
                  </Multiselect>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  v-if="initiatorRendered"
                >
                  <Multiselect
                    label="FIO"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!initiatorRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.initiator"
                    :options="initiators"
                    placeholder="Инициатор"
                  >
                    <span slot="noResult">Инициатор не найден</span>
                    <span slot="noOptions">Инициатор не найден</span>
                  </Multiselect>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  v-if="performerRendered"
                >
                  <Multiselect
                    label="FIO"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!performerRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.performer"
                    :options="performers"
                    placeholder="Ответственный"
                  >
                    <span slot="noResult">Ответственный не найден</span>
                    <span slot="noOptions">Ответственный не найден</span>
                  </Multiselect>
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    :loading="!isOrgLoading"
                    v-model="filter.organization"
                    :options="organizations"
                    placeholder="Организация"
                    @search-change="findOrg"
                  >
                    <span slot="noResult">Организация не найдена</span>
                  </Multiselect>
                </div>
                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      @click="clearFilter"
                      type="button"
                    >
                      Сброс
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-fullЭ"
                      type="button"
                      @click="applyFilter"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="table-responsive container-stl" v-if="!isExpsLoading">
            <table class="table  table-hover table-striped table-new-style">
              <thead>
              <tr>
                <th class="text-nowrap">
                  Карточка запроса
                </th>
                <th class="text-nowrap">
                  №<a
                  v-on:click="setOrder('UF_NUMBER')"
                  class="sort"
                  v-bind:class="{
                        desc: sortColumn === 'UF_NUMBER' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  № проекта<a
                  v-on:click="setOrder('PROJECT_UF_NUMBER')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'PROJECT_UF_NUMBER' &&
                          sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Организация<a
                  v-on:click="setOrder('COMPANY_NAME')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'COMPANY_NAME' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Инициатор<a
                  v-on:click="setOrder('INITIATOR_NAME')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'INITIATOR_NAME' &&
                          sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Дата создания<a
                  v-on:click="setOrder('UF_DATE_CREATE')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'UF_DATE_CREATE' &&
                          sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Статус<a
                  v-on:click="setOrder('UF_STATUS_ID')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'UF_STATUS_ID' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Дата завершения<a
                  v-on:click="setOrder('UF_DATE_COMPETION')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'UF_DATE_COMPETION' &&
                          sortOrder === 'DESC'
                      }"
                ></a>
                </th>
<!--                <th class="text-nowrap">
                  Тема запроса<a
                  v-on:click="setOrder('UF_THEME')"
                  class="sort"
                  v-bind:class="{
                        desc: sortColumn === 'UF_THEME' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>-->
                <th class="text-nowrap">
                  Тип<a
                  v-on:click="setOrder('UF_TYPE_ID')"
                  class="sort"
                  v-bind:class="{
                        desc: sortColumn === 'UF_TYPE_ID' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Текст<a
                  v-on:click="setOrder('UF_TEXT')"
                  class="sort"
                  v-bind:class="{
                        desc: sortColumn === 'UF_TEXT' && sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <th class="text-nowrap">
                  Ответственный<a
                  v-on:click="setOrder('PERFORMER_NAME')"
                  class="sort"
                  v-bind:class="{
                        desc:
                          sortColumn === 'PERFORMER_NAME' &&
                          sortOrder === 'DESC'
                      }"
                ></a>
                </th>
                <td></td>
              </tr>
              </thead>
              <tbody v-if="requests && requests.counts">
              <tr
                class="new"
                unselectable="on"
                style="cursor: default"
                v-for="project in requests.items"
                v-bind:key="project.ID"
              >
                <td>
                  <router-link
                    :to="{
                        name: 'RequestEdit',
                        params: { id: project.ID }
                      }"
                    class="project-filter__butt-btn butt-new-style butt-new-style-reest"
                    style="max-width: 120px;"
                    target="_blank"
                  >
                   Перейти
                  </router-link>
                </td>
                <td>
                    {{ project.UF_NUMBER }}
                </td>
                <td>
                  <router-link
                    v-if="project && project.UF_PROJECT_ID > 1"
                    :to="{
                        name: 'AddDZ',
                        params: { id: project.UF_PROJECT_ID }
                      }"
                    style="color: #002333; text-decoration-line: underline;"
                  >
                    {{ project.PROJECT_UF_NUMBER }}
                  </router-link>
                  <template v-else>{{ project.PROJECT_UF_NUMBER }}</template>
                </td>
                <td>
                  {{ project.COMPANY.NAME }}
                </td>
                <td>{{ project.INITIATOR.NAME }}</td>
                <td>{{ project.UF_DATE_CREATE }}</td>
                <td>{{ project.STATUS.NAME }}</td>
                <td>{{ project.UF_DATE_COMPETION }}</td>
                <td>{{ project.TYPE_NAME }}</td>
                <td>{{ project.UF_TEXT }}</td>
                <td>{{ project.PERFORMER.NAME }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="8">Записи не найдены</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="11">
                  <div class="paging">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-xs-6 mycol">
                          <Pagination
                            :pages="pages"
                            :currentPage.sync="currentPage"
                          ></Pagination>
                        </div>
                        <div class="col-xs-6 mycol">
                          <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                              >Всего: {{ requests.counts }}</span
                              >
                            <span>Выводить по </span>
                            <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>

          <div
            class="modal fade in"
            v-bind:class="{ show: showEditNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="createRequest">
              <div class="modal-dialog modal-dialog-datepicker-right modal-close-active modal-new-style"
                   role="document">
                <div class="modal-content add-new-type-document-check-list">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showEditNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Создание запроса</h4>
                  </div>
                  <div class="modal-body boldlabel">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>
                    <!--                    <div class="form-group">
                                          <div class="controller stl-controller-wrapper">
                                            <label>Проект <sup class="red">*</sup></label>
                                            <Multiselect
                                              label="UNION_INFO"
                                              class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                                              :loading="!loadProjectsList"
                                              :limit="1"
                                              :limitText="filterItemText"
                                              track-by="ID"
                                              v-model="newRequest.UF_PROJECT_ID"
                                              :options="projects"
                                              placeholder=""
                                              :multiple="false"
                                            >
                                              <span slot="noResult">Проект не найден</span>
                                            </Multiselect>
                                          </div>
                                        </div>-->

                    <div class="form-group"
                         v-bind:class="{'has-error': checkErrorField('UF_PROJECT_ID')}">
                      <div class="controller stl-controller-wrapper">
                        <label>Проект <sup class="red">*</sup></label>
                        <v-autocomplete
                          :items="projects"
                          input-class="form-control i-main-style"
                          :auto-select-one-item="false"
                          :keep-open="false"
                          :component-item="act"
                          v-model="selectedProject"
                          :min-len="1"
                          :get-label="getLabel"
                          placeholder="Введите номер проекта"
                          @update-items="updateItems"
                          @input="selectProjectItems"
                        ></v-autocomplete>
                      </div>
                    </div>

                    <div class="form-group"
                         v-bind:class="{'has-error': checkErrorField('UF_TYPE_ID')}">
                      <label class="bold"
                      >Тип запроса <sup class="red">*</sup></label
                      >
                      <select
                        class="form-control i-main-style"
                        v-model="newRequest.UF_TYPE_ID"
                        @change="changeType()"
                      >
                        <option
                          :key="project.ID"
                          v-for="project in directory.hl_request_type"
                          :value="project.ID"
                          v-text="project.UF_NAME"
                        ></option>
                      </select>
                    </div>

                    <div
                      class="form-group"
                      v-bind:class="{'has-error': checkErrorField('UF_SCONDITION_DZ_ID')}"
                      v-if="newRequest.UF_TYPE_ID == 8 && newRequest.UF_PROJECT_ID.ID > 0 "
                    >
                      <div class="controller stl-controller-wrapper">
                        <label>Отлагательное условие <sup class="red">*</sup></label
                        >
<!--                        <Multiselect
                          label="UF_NAME_RECORD"
                          class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                          style="height: auto; min-height: 40px;"
                          :limit="1"
                          :limitText="filterItemText"
                          track-by="ID"
                          placeholder
                          v-model="newRequest.UF_SCONDITION_DZ_ID"
                          :options="newRequest.UF_PROJECT_ID.SCONDITION_LIST"
                          :multiple="false"
                        >
                          <span slot="noResult">Нет отлагательных условий</span>
                          <span slot="noOptions">Нет отлагательных условий</span>

                        </Multiselect>-->
                        <select
                          v-model="newRequest.UF_SCONDITION_DZ_ID"
                          @change="removeError('UF_SCONDITION_DZ_ID')"
                          class="form-control i-main-style">
                          <option v-for="text in  newRequest.UF_PROJECT_ID.SCONDITION_LIST"
                                  :value="text.ID">
                            {{text.UF_NAME_RECORD}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <!--                    <div class="form-group">
                                          <label>Тема <sup class="red">*</sup></label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            v-model="newRequest.UF_THEME"
                                          />
                                        </div>-->
                    <div class="form-group"
                         v-bind:class="{'has-error': checkErrorField('UF_TEXT')}">
                      <label>Запрос <sup class="red">*</sup></label>
                      <textarea
                        class="form-control i-main-style"
                        v-model="newRequest.UF_TEXT"
                        @keyup="removeError('UF_TEXT')"
                      >
                      </textarea>
                    </div>
<!--                    <div class="form-group"
                         v-bind:class="{'has-error': checkErrorField('UF_PERFORMER_ID')}">
                      <label>Исполнитель <sup class="red">*</sup></label>
                      <multiselect
                        label="FIO"
                        class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                        :limit="1"
                        :limitText="filterItemText"
                        track-by="ID"
                        v-model="newRequest.UF_PERFORMER_ID"
                        :options="
                          requests.DEFAULT_SETTINGS
                            ? requests.DEFAULT_SETTINGS
                                .PERFORMER_LIST_CREATE_REQUEST
                            : []
                        "
                        placeholder=""
                        @input="removeError('UF_PERFORMER_ID')"
                      >
                        <span slot="noResult">Исполнитель не найден</span>
                      </multiselect>
                      &lt;!&ndash;<select
                        class="form-control"
                        v-model="newRequest.UF_PERFORMER_ID"
                        :disabled="newRequestType().UF_DEF_PERFORMER_ID"
                      >
                        <option
                          :key="item.ID"
                          v-for="item in requests.DEFAULT_SETTINGS
                            .PERFORMER_LIST_CREATE_REQUEST"
                          :value="item.ID"
                          v-text="item.FIO"
                        ></option>
                      </select>&ndash;&gt;
                    </div>-->
                    <div
                      class="form-group"
                      v-if="newRequestType().UF_IS_POSSIBLE_PERIOD_EXECUTION"
                    >
                      <label>Срок исполнения</label>
                      <datepicker
                        v-model="newRequest.UF_PERIOD_EXECUTION"
                        :language="ru"
                        :format="dateFormat"
                        input-class="form-control filter-input-datapicer form-control-data-inp_"
                        :monday-first="true"
                      ></datepicker>
                    </div>
                    <!--                    <div
                                          class="form-group"
                                          v-if="newRequestType().UF_IS_LIST_TO_APPROVE"
                                        >
                                          <label>Лист согласования</label>
                                          <Multiselect
                                            label="FIO"
                                            style="width: 540px;height: 50px"
                                            class="form-control"
                                            :limit="10"
                                            :limitText="filterItemText"
                                            track-by="ID"
                                            v-model="newRequest.UF_LIST_MAIN_APPROVE_USERS_ID"
                                            :options="
                                              requests.DEFAULT_SETTINGS
                                                ? requests.DEFAULT_SETTINGS
                                                    .APPROVE_LIST_CREATE_REQUEST
                                                : []
                                            "
                                            :multiple="true"
                                            placeholder=""
                                          >
                                            <span slot="noResult">Пользователи не найдены</span>
                                          </Multiselect>
                                        </div>-->

                    <div
                      v-if="file.name"
                      class="form-group"
                      v-for="(file, index) in fileList"
                    >
                      <div class="form-group__file-name">
                        {{ file.name }} {{ file.size }}
                        <i
                          class="i-delete "
                          title="Удалить запись"
                          @click="deleteFileItem(index)"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-for="(file, index) in fileList"
                      v-show="
                        file.showed &&
                          (newRequestType().UF_IS_LOAD_FILE ||
                            newRequestType().UF_IS_NEED_LOAD_FILE)
                      "
                    >
                      <div class="file-upload butt-pointer" style="width: 168px; cursor:pointer;">
                        <button type="button" class="btn btn-primary">
                          Загрузить документ
                        </button>
                        <input
                          v-show="file.showed"
                          type="file"
                          name="file"
                          ref="file"
                          :index="index"
                          @change="changeFile"
                          style="width: 156px; height: 60px;"
                        />
                      </div>
                    </div>

                  </div>
                  <div class="modal-footer" style="margin-bottom: 20px;">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="showEditNewProject = false"
                    >
                      Отмена
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      :disabled="isSendRequest"
                    >
                      Отправить
                    </button>
                  </div>
                </div>
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
        </div>
      </div>
      <!-- wraper -->
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  FETCH_DIRECTORIES,
  FETCH_REQUESTS,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { ProjectsService, RequestsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Item from "@/components/expert/Item.vue";
import Vue from "vue";
import ForbiddenPage403 from "@/components/ForbiddenPage403.vue";

export default {
  title: "Запросы",
  components: {
    Pagination,
    Datepicker,
    Multiselect,
    ForbiddenPage403
  },
  data() {
    return {
      siteUrl: "",
      extendFilter: false,
      filter: {
        number: "",
        project_number: "",
        status: "",
        initiator: "",
        organization: "",
        performer: "",
        types: ""
      },
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showEditNewProject: false,
      listRendered: false,
      statusRendered: false,
      initiatorRendered: false,
      performerRendered: false,
      sp: {
        statuses: []
      },
      ru: ru,
      newRequest: {
        UF_PROJECT_ID: "",
        UF_TYPE_ID: "",
        UF_THEME: "",
        UF_TEXT: "",
        UF_PERFORMER_ID: "",
        UF_PERIOD_EXECUTION: "",
        UF_FILE_ID: []
      },
      addError: "",
      filter_status: [],
      statuses: [],
      types:[],
      initiators: [],
      performers: [],
      projects: [],
      loadProjectsList: false,
      organizations: [],
      isEdit: false,
      isOrgLoading: false,
      fileList: [],
      isSetPhilterUser: 0,
      act: Item,
      items: [],
      selectedProject: null,
      saveErrorFields: [],
      isSendRequest: false,
    };
  },
  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      this.isEdit = data.IS_REDACT_GROUP_ORG;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/
        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }
      } else {
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }*/
        if (data.IS_VIEW_REQUEST_MODULE) {
          navMainMenu.push({
            name: "Запросы",
            route: "Requests"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
    });

    this.$store.dispatch(FETCH_DIRECTORIES, [
      "hl/request_status",
      "hl/request_type"
    ]);

    /*ProjectsService.getListProjectsForRequest().then(({ data }) => {
      this.projects = data.items;
      this.loadProjectsList = true;

      if (this.$route.query.action && this.$route.query.action == "create") {
        this.showEditNewProject = true;

        if (this.$route.query.idProject && this.$route.query.idProject > 0) {
          this.newRequest.UF_PROJECT_ID = this.projects.filter(c => c.ID == this.$route.query.idProject);
        }
      }
    });*/
    this.fetchList();

    if (this.$route.query.action && this.$route.query.action == "create") {
      if (this.$route.query.idProject && this.$route.query.idProject > 0) {
        // this.newRequest.UF_PROJECT_ID = this.$route.query.idProject;
        this.getActiveItemProject(this.$route.query.idProject);
        //this.newRequest.UF_PROJECT_ID = this.projects.filter(c => c.ID == this.$route.query.idProject);
        this.showEditNewProject = true;
      }
    }

    if (this.$route.query.filter !== undefined) {
      let filter = JSON.parse(this.$route.query.filter);
      this.filter = { ...filter };
    }



  },
  computed: {
    ...mapGetters([
      "requests",
      "addProjectError",
      "isExpsLoading",
      "currentUser",
      "directory"
    ]),
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      return q;
    },
    filterConfig() {
      let filterForm = this.filter;
      if (this.$route.query.filter !== undefined) {
        filterForm = JSON.parse(this.$route.query.filter);
      }

      const f = {
        UF_NUMBER: filterForm.number ? filterForm.number : "",
        PROJECT_UF_NUMBER: filterForm.project_number
          ? filterForm.project_number
          : "",
        UF_STATUS_ID:
          filterForm.status && Array.isArray(filterForm.status)
            ? filterForm.status.map(el => el.ID).join(",")
            : filterForm.status.ID
              ? filterForm.status.ID
              : "",
        UF_TYPE_ID:
          filterForm.types && Array.isArray(filterForm.types)
            ? filterForm.types.map(el => el.ID).join(",")
            : (filterForm.types.ID !== undefined)
              ? filterForm.types.ID
              : "",
        UF_CREATED_BY:
          filterForm.initiator && filterForm.initiator.ID
            ? filterForm.initiator.ID
            : "",
        UF_PERFORMER_ID:
          filterForm.performer && filterForm.performer.ID
            ? filterForm.performer.ID
            : "",
        UF_COMPANY_ID:
          filterForm.organization && filterForm.organization.ID
            ? filterForm.organization.ID
            : "",
        isSetPhilterUser: this.isSetPhilterUser
      };
      return f;
    },
    pages() {
      if (
        this.isRequestsLoading ||
        !this.requests.counts ||
        this.requests.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.requests.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchList();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchList();
    }
  },
  methods: {
    getAvailableTheme() {
      let t = this.directory.hl_request_type.filter(
        c => c.UF_IS_AVAILABLE_CREATE === 1
      );

      return t;
    },
    newRequestType() {
      let t = this.directory.hl_request_type.filter(
        c => c.ID === this.newRequest.UF_TYPE_ID
      );
      if (t && t.length > 0) {
        return t[0];
      }
      return {};
    },
    changeType() {
      this.removeError('UF_TYPE_ID');
      if (this.newRequestType().UF_DEF_PERFORMER_ID > 0) {
        //this.newRequest.UF_PERFORMER_ID = this.newRequestType().UF_DEF_PERFORMER_ID;
        this.newRequest.UF_PERFORMER_ID = this.requests.DEFAULT_SETTINGS.PERFORMER_LIST_CREATE_REQUEST.filter(
          c => c.ID === this.newRequestType().UF_DEF_PERFORMER_ID
        );
        this.removeError('UF_PERFORMER_ID');
      } else {
        this.newRequest.UF_PERFORMER_ID = {};
      }
    },
    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchList();
    },
    clearFilter() {
      this.filter = {
        number: "",
        project_number: "",
        status: "",
        initiator: "",
        organization: "",
        performer: "",
        types: ""
      };
      this.applyFilter();
    },
    applyFilter() {
      this.isSetPhilterUser = 1;
      /*this.$router.push({
        path: "/requests",
        query: { filter: JSON.stringify(this.filter) }
      });*/

      this.$router.push({
        path: "/requests",
        query: { filter: JSON.stringify(this.filter) }
      }).catch(err => {
        // Игнорируем ошибки относящиеся к переходу на ту же самую страницу
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // но выводим/обрабатываем все прочие ошибки
          console.error(err);
        }
      });

      this.fetchList();
    },
    fetchList() {
      this.$store
        .dispatch(FETCH_REQUESTS, {
          ...this.listConfig,
          filter: { ...this.filterConfig }
        })
        .then(() => {
          this.statuses = this.directory.hl_request_status;
          this.types = this.directory.hl_request_type;
          this.statusRendered = true;
          this.initiators = this.requests.DEFAULT_SETTINGS.INITIATOR_LIST;
          this.initiatorRendered = true;
          this.performers = this.requests.DEFAULT_SETTINGS.PERFORMER_LIST;
          this.performerRendered = true;

          this.organizations = this.requests.DEFAULT_SETTINGS.ORG_LIST;
          this.isOrgLoading = true;

          if (!this.isSetPhilterUser) {
            this.filter.status = this.statuses[0];
          }
          if (!this.filter.performer && !this.isSetPhilterUser) {
            this.filter.performer = this.requests.DEFAULT_SETTINGS.UF_PERFORMER_USER;
          }

          if (!this.filter.initiator && !this.isSetPhilterUser) {
            this.filter.initiator = this.requests.DEFAULT_SETTINGS.UF_INICIATOR_USER;
          }

        }).catch( error => {
        if (error.message.includes("HttpCode:403")) {
          this.$router.push({ name: "ForbiddenPage403" });
        }

      });
    },
    createRequest() {
      this.isSendRequest = true;
      this.saveErrorFields = [];
      let formData = new FormData();
      //formData.append("UF_PROJECT_ID", (this.selectedProject && this.selectedProject.ID > 0)?this.selectedProject.ID:this.newRequest.UF_PROJECT_ID.ID);
      formData.append("UF_PROJECT_ID", (this.selectedProject && this.selectedProject.ID > 0)?this.selectedProject.ID:0);
      formData.append("UF_TYPE_ID", this.newRequest.UF_TYPE_ID);
      formData.append("UF_THEME", this.newRequest.UF_THEME);
      formData.append("UF_TEXT", this.newRequest.UF_TEXT);
      formData.append(
        "UF_PERFORMER_ID",
        this.newRequest.UF_PERFORMER_ID[0]
          ? this.newRequest.UF_PERFORMER_ID[0].ID
          : this.newRequest.UF_PERFORMER_ID.ID
      );

      if (
        this.newRequest.UF_LIST_MAIN_APPROVE_USERS_ID &&
        this.newRequest.UF_LIST_MAIN_APPROVE_USERS_ID.length
      ) {
        // let f = [];
        this.newRequest.UF_LIST_MAIN_APPROVE_USERS_ID.forEach(v => {
          //f.push(v.ID);
          formData.append("UF_LIST_MAIN_APPROVE_USERS_ID[]", v.ID);
        });
        //formData.append("UF_LIST_MAIN_APPROVE_USERS_ID[]", f);
      }

      formData.append(
        "UF_PERIOD_EXECUTION",
        moment(this.newRequest.UF_PERIOD_EXECUTION).format("YYYY-MM-DD HH:mm:ss"),
      );

      if (this.$refs.file && this.$refs.file.length) {
        for (let v = 0; v < this.$refs.file.length; v++) {
          for (let i = 0; i < this.$refs.file[v].files.length; i++) {
            formData.append("UF_FILE_ID[]", this.$refs.file[v].files[i]);
          }
        }
      }

      if (this.newRequest.UF_SCONDITION_DZ_ID) {
        formData.append("UF_SCONDITION_DZ_ID", this.newRequest.UF_SCONDITION_DZ_ID);
      }

      RequestsService.createRequest(formData).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });

            this.saveErrorFields.push({"FILED":text.TEXT});
            //this.saveErrorFields[text.FIELD] = err.TEXT;
            Vue.set(this.saveErrorFields, `${text.FIELDS}`, `${text.TEXT}`);


          }, this);

        } else {
          this.showEditNewProject = false;
          this.newRequest.UF_PROJECT_ID = "";
          this.newRequest.UF_TYPE_ID = "";
          this.newRequest.UF_THEME = "";
          this.newRequest.UF_TEXT = "";
          this.newRequest.UF_PERFORMER_ID = this.requests.DEFAULT_SETTINGS.PERFORMER_CREATE_REQUEST_DEF;
          this.newRequest.UF_SCONDITION_DZ_ID = "";
          this.newRequest.UF_PERIOD_EXECUTION = "";
          this.newRequest.UF_FILE_ID = [];

          this.fileList = [];
          this.fetchList();

          this.$toasted.show("Запрос успешно создан", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }

        console.log(this.saveErrorFields);

        this.isSendRequest = false;

      });
    },
    changeFile(e) {
      let index = e.target.getAttribute("index");
      this.fileList[index].name = e.target.files[0].name;
      this.fileList[index].size = this.humanFileSize(e.target.files[0].size);
      this.fileList[index].showed = false;
      index++;
      if (this.fileList[index]) {
        this.fileList[index].showed = true;
      }
    },
    findOrg(q) {
      if (q.length < 3) return;
      this.isOrgLoading = true;
      RequestsService.getListOrgs({ filter: { UF_NAME: q } }).then(
        ({ data }) => {
          this.organizations = data;
          this.isOrgLoading = true;
        }
      );
    },
    showNewRequestForm() {
      this.selectedProject = null;
      this.newRequest.UF_PROJECT_ID = "";
      this.newRequest.UF_TYPE_ID = "";
      this.newRequest.UF_THEME = "";
      this.newRequest.UF_TEXT = "";
      this.newRequest.UF_PERFORMER_ID = this.requests.DEFAULT_SETTINGS.PERFORMER_CREATE_REQUEST_DEF;
      this.newRequest.UF_PERIOD_EXECUTION = "";
      this.newRequest.UF_SCONDITION_DZ_ID = "";
      this.newRequest.UF_FILE_ID = [];

      this.fileList = [];

      this.showEditNewProject = true;
      this.saveErrorFields = [];
      this.fillFiles();
    },
    fillFiles() {
      for (let i = 0; i < 20; i++) {
        this.fileList.push({
          isAdded: false,
          showed: i === 0,
          name: ""
        });
      }
    },
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = ["кБ", "МБ", "ГБ", "TB", "PB", "EB", "ZB", "YB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
        );

      return bytes.toFixed(dp) + " " + units[u];
    },
    deleteFileItem(index) {
      this.fileList.splice(index, 1);
      this.fileList.push({
        isAdded: false,
        showed: false,
        name: ""
      });
      let sLast = true;
      this.fileList.forEach(v => {
        if (v.showed === true) {
          sLast = false;
        }
      });
      if (sLast) {
        this.fileList[this.fileList.length - 1].showed = true;
      }
    },
    filterItemText(count) {
      return ``;
      //return `и еще ${count}`;
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
        //return item.UF_NUMBER;
      }
    },
    getActiveItemProject(idProject) {
      ProjectsService.getListProjectsForRequest({ idProject: idProject }).then(({ data }) => {
        this.projects = data.items;
        this.newRequest.UF_PROJECT_ID = this.projects[1];
        this.newRequest.UF_PERFORMER_ID = data.DEFAULT_SETTINGS.PERFORMER_CREATE_REQUEST_DEF;
        if (!this.requests){
          this.requests.DEFAULT_SETTINGS.PERFORMER_LIST_CREATE_REQUEST = data.DEFAULT_SETTINGS.PERFORMER_CREATE_REQUEST_DEF;
        }
        this.selectedProject= this.projects[1];
        this.loadProjectsList = true;
      });
    },
    updateItems(query) {
      if (query !== undefined) {
        ProjectsService.getListProjectsForRequest({ search: query }).then(({ data }) => {
          this.projects = data.items;
          this.loadProjectsList = true;
        });
      }
    },
    selectProjectItems() {
      // this.resetForm();
      this.removeError('UF_PROJECT_ID');
      if (this.selectedProject == null && this.projects.length == 0) {
         this.projects.push({'ID':1, 'UNION_INFO':"Без указания проекта",'UF_NUMBER': "",'UF_NAME': "Без указания проекта"});
      }

      if (this.newRequest.UF_PROJECT_ID !== null) {
        if (this.selectedProject && this.selectedProject.ID > 0) {
          this.newRequest.UF_PROJECT_ID = this.selectedProject;
          this.isLoadListDocuments = true;
          this.docList = null;
         /* ProjectsService.getDocumentDZProjects(this.newRequest.UF_PROJECT_ID).then(
            ({ data }) => {
              this.docList = data;
              this.isLoadListDocuments = false;
            }
          );*/
        } else {
          this.docList = null;
        }
      }
    },
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    checkErrorField(field) {
      if (typeof this.saveErrorFields[field] === "undefined") {
        return false;
      }
      return true;
    },
    removeError(field) {
      if (typeof this.saveErrorFields[field] === "undefined") {
        return "";
      }else{
        delete  this.saveErrorFields[field];
      }

      this.addError = "";


      Vue.delete(this.saveErrorFields, field);
    },
  }
};
</script>
